import { createHook } from 'react-sweet-state';
import { store } from '../index';
import { initialAttachmentState } from '../utils';

// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
var getIssueAttachment = function getIssueAttachment(state, issueKey) {
  return state.issueAttachments[issueKey] || initialAttachmentState;
};
var getIsFetching = function getIsFetching(state, issueKey) {
  return getIssueAttachment(state, issueKey).isFetching;
};
var getError = function getError(state, issueKey) {
  return getIssueAttachment(state, issueKey).error;
};
var getOrderDirection = function getOrderDirection(state) {
  return state.meta.orderDirection;
};
var getOrderField = function getOrderField(state) {
  return state.meta.orderField;
};
var getTotalCount = function getTotalCount(state, issueKey) {
  return getIssueAttachment(state, issueKey).totalCount;
};
var getDeletableCount = function getDeletableCount(state, issueKey) {
  return getIssueAttachment(state, issueKey).deletableCount;
};
var getStartAt = function getStartAt(state) {
  return state.meta.startAt;
};
var getVisibleAttachments = function getVisibleAttachments(state, issueKey) {
  return getIssueAttachment(state, issueKey).visibleAttachments;
};
export var useAttachmentStoreIsFetching = createHook(store, {
  selector: getIsFetching
});
export var useAttachmentStoreError = createHook(store, {
  selector: getError
});
export var useAttachmentStoreOrderDirection = createHook(store, {
  selector: getOrderDirection
});
export var useAttachmentStoreOrderField = createHook(store, {
  selector: getOrderField
});
export var useAttachmentStoreTotalCount = createHook(store, {
  selector: getTotalCount
});
export var useAttachmentStoreDeletableCount = createHook(store, {
  selector: getDeletableCount
});
export var useAttachmentStoreStartAt = createHook(store, {
  selector: getStartAt
});
export var useAttachmentStoreVisibleAttachments = createHook(store, {
  selector: getVisibleAttachments
});
export var useAttachmentStoreActions = createHook(store, {
  selector: null
});